"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCumulativeStageCounts = exports.mergeFunnelCounts = exports.totalFunnelCount = exports.getDisqualReasonLabel = exports.clientStages = exports.hiredStage = exports.offerStage = exports.clientFinalRoundStage = exports.clientMiddleRoundStage = exports.clientFirstRoundStage = exports.awaitingClientStage = exports.amRejected = exports.amSubmitApproved = exports.awaitingAMApproval = exports.amRequestedInfo = exports.waitingForDocsStage = exports.rocketScreenCompleteStage = exports.rocketScreenScheduledStage = exports.beingScheduledStage = exports.responseReceivedStage = exports.outreachSentStage = exports.outreachScheduledStage = exports.emailFoundStage = exports.sourcedStage = exports.notRightNowStage = exports.emailNotFoundStage = exports.emailRequestedStage = exports.autoSourcedStage = void 0;
const _ = require("lodash");
exports.autoSourcedStage = 'auto_sourced';
exports.emailRequestedStage = 'email_requested';
exports.emailNotFoundStage = 'email_not_found';
exports.notRightNowStage = 'not_right_now';
exports.sourcedStage = 'sourced';
exports.emailFoundStage = 'email_found';
exports.outreachScheduledStage = 'outreach_scheduled';
exports.outreachSentStage = 'outreach_sent';
exports.responseReceivedStage = 'response_received';
exports.beingScheduledStage = 'being_scheduled';
exports.rocketScreenScheduledStage = 'rocket_screen_scheduled';
exports.rocketScreenCompleteStage = 'rocket_screen_complete';
exports.waitingForDocsStage = 'waiting_for_docs';
exports.amRequestedInfo = 'am_requested_info';
exports.awaitingAMApproval = 'awaiting_am_approval';
exports.amSubmitApproved = 'am_submit_approved';
exports.amRejected = 'am_rejected';
exports.awaitingClientStage = 'awaiting_client_feedback';
exports.clientFirstRoundStage = 'client_first_round';
exports.clientMiddleRoundStage = 'client_middle_round';
exports.clientFinalRoundStage = 'client_second_round';
exports.offerStage = 'offer';
exports.hiredStage = 'hired';
exports.clientStages = [exports.clientFirstRoundStage, exports.clientMiddleRoundStage, exports.clientFinalRoundStage, exports.offerStage];
const getDisqualReasonLabel = (reason, prefix = false) => {
    const labels = new Map([
        ['candidate_declined_compensation_issue', 'Compensation'],
        ['candidate_declined_contract_only', 'Contract only'],
        ['candidate_declined_permanent_only', 'Permanent only'],
        ['candidate_declined_do_not_email', 'Do not email'],
        ['candidate_declined_location_not_a_fit', 'Location not a fit'],
        ['candidate_declined_not_interested_in_role', 'Not interested'],
        ['candidate_declined_not_right_time', 'Not right time'],
        ['candidate_declined_remote_only', 'Remote only'],
        ['candidate_declined_withdrawing', 'Withdrawing'],
        ['candidate_declined_ooo_response', 'OOO Response'],
        ['candidate_declined_incorrect_email', 'Incorrect Email'],
        ['candidate_declined_never_started', 'Never started'],
        ['candidate_declined_resigned_within_guarantee_period', 'Resigned within guarantee period'],
        ['candidate_declined_hybrid_only', 'Hybrid only'],
        ['candidate_declined_already_interviewed_with_client', 'Already in contact with client'],
        ['candidate_declined_role_not_a_fit', 'Role not a fit'],
        ['recruiter_declined_overqualified', 'Overqualified'],
        ['recruiter_declined_added_by_mistake', 'Added by mistake'],
        ['recruiter_declined_get_resume_comp_first', 'Get resume/comp first'],
        ['recruiter_declined_not_a_fit_requirements_changed', 'Client requirements changed'],
        ['recruiter_declined_not_a_fit_ml_search_was_off', 'Poor fit'],
        ['recruiter_declined_blacklisted_profile', 'Blacklist Check'],
        ['recruiter_declined_gone_cold', 'Gone cold'],
        ['recruiter_declined_not_qualified_on_review', 'Not qualified'],
        ['recruiter_declined_visa_issue', 'Visa issue'],
        ['recruiter_declined_get_ai_interview_done', 'Send AI interview'],
        ['client_declined_not_qualified', "Didn't pass bar"],
        ['client_declined_not_right_time', 'Not right time'],
        ['client_declined_compensation_mismatch', 'Compensation'],
        ['client_declined_overqualified', 'Overqualified'],
        ['client_declined_pulled_offer', 'Pulled offer'],
        ['client_declined_fired_within_guarantee_period', 'Fired within guarantee period'],
        ['titan_declined_gone_cold', 'Gone Cold']
    ]);
    let label = labels.get(reason);
    if (prefix) {
        if (reason.match(/^candidate_declined/)) {
            label = `Candidate Declined: ${label}`;
        }
        else if (reason.match(/^recruiter_declined/)) {
            label = `Rocket Declined: ${label}`;
        }
        else if (reason.match(/^client_declined/)) {
            label = `Client Declined: ${label}`;
        }
    }
    return label;
};
exports.getDisqualReasonLabel = getDisqualReasonLabel;
const totalFunnelCount = (c) => {
    return _.sum(_.values(c));
};
exports.totalFunnelCount = totalFunnelCount;
const mergeFunnelCounts = (c1, c2) => {
    return _.mergeWith({}, c1, c2, (x, y) => (x || 0) + (y || 0));
};
exports.mergeFunnelCounts = mergeFunnelCounts;
const cumulativeStageCount = (stage, job, stages) => {
    const stageCount = job.stageFunnelCounts[stage.name]
        ? (0, exports.mergeFunnelCounts)(job.stageFunnelCounts[stage.name].qualified, job.stageFunnelCounts[stage.name].disqualified)
        : {};
    if (!stage.funnelNextStage) {
        return stageCount;
    }
    else {
        const nextStage = stages.find((s) => s.name === stage.funnelNextStage);
        return (0, exports.mergeFunnelCounts)(stageCount, _.pick(cumulativeStageCount(nextStage, job, stages), stage.funnels));
    }
};
const getCumulativeStageCounts = (job, stages) => {
    return stages.reduce((accumulatedCount, currentStage) => {
        if (currentStage.funnels) {
            accumulatedCount[currentStage.name] = cumulativeStageCount(currentStage, job, stages);
        }
        return accumulatedCount;
    }, {});
};
exports.getCumulativeStageCounts = getCumulativeStageCounts;
//# sourceMappingURL=job-stages.js.map